import gql from 'graphql-tag';
import React, { useEffect, useState } from 'react';
import { withApollo } from 'react-apollo';
import { Button, Card, Flex, Text } from 'rebass';
import { RetellWebClient } from 'retell-client-js-sdk';
import styled from 'styled-components';
import { keyframes } from 'styled-components';
import { sleep } from '../utils/sleep';
import { removeRetellWidget } from '../utils/retellWidget';

export const GET_TOKEN = gql`
  query getRetellWebCall {
    getRetellWebCall {
      accessToken
    }
  }
`;
const circleSize = keyframes`
  from {
    width: 15px;
    height: 15px;
  }
  to {
    width: 18px;
    height: 18px;
  }
`;

const shadowRotate = keyframes`
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
`;
const Mic = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 100%;
    z-index: 2;
    box-shadow: 0 0 2px 2px #1c084f;
    width: 24px; /* Adjusted size */
    height: 24px; /* Adjusted size */
    background-color: #1a084e;
  }
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 100%;
    z-index: 2;
    box-shadow: 0 0 2px 2px #1c084f;
    width: 15px; /* Adjusted size */
    height: 15px; /* Adjusted size */
    background-color: #2f1e5f;
    animation: ${circleSize} 0.8s linear infinite alternate;
  }
`;

const MicIcon = styled.i`
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.6); /* Adjusted scale */
  display: block;
  width: 2px; /* Adjusted size */
  height: 1.8px; /* Adjusted size */
  border-bottom-left-radius: 15px; /* Adjusted radius */
  border-bottom-right-radius: 15px; /* Adjusted radius */
  border: 1px solid; /* Adjusted border width */
  border-top: 0;
  margin-top: 2px; /* Adjusted margin */
  z-index: 3;
  &::before {
    content: '';
    display: block;
    box-sizing: border-box;
    position: absolute;
    width: 0.3px; /* Adjusted size */
    height: 0.8px; /* Adjusted size */
    top: calc(100% + 1px);
    left: 50%;
    transform: translate(-50%, 0);
    background-color: #fff;
  }
  &::after {
    content: '';
    display: block;
    box-sizing: border-box;
    position: absolute;
    border: 1px solid;
    width: 1.6px; /* Adjusted size */
    height: 3.5px; /* Adjusted size */
    left: 50%;
    top: -4px; /* Adjusted position */
    border-radius: 2px; /* Adjusted radius */
    transform: translate(-50%, 0);
  }
`;
const MicShadow = styled.div`
  width: 24px; /* Adjusted size */
  height: 24px; /* Adjusted size */
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 100%;
  z-index: 1;
  box-shadow: 2px -3px 6px 3px #823ca6, 5px -2px 6px 2px #aab3d2, -1px -6px 3px 2px #5acee3, 3px 1px 4px 2px #1b7d8f, 1px 1px 3px 2px #f30bf5; /* Adjusted shadow sizes */
  animation: ${shadowRotate} ${(props) => (props.isActive ? 1.5 : 5)}s linear infinite;
  transform-origin: center;
  opacity: ${(props) => (props.isActive ? 1 : 0.65)};
`;
let retellWebClient = new RetellWebClient();
const RetellWebCallComponent = ({ client, forceNewComponent }) => {
  const [isCallStarted, setIsCallStarted] = useState(false);
  const [initializingCall, setInitializingCall] = useState(false);
  const [isAgentTalking, setIsAgentTalking] = useState(false);

  const onStopPressed = () => {
    if (!!retellWebClient) {
      retellWebClient.stopCall();
      console.log('call is closed');
      setIsCallStarted(false);
      setIsAgentTalking(false);
      forceNewComponent();
    } else {
      console.log('no client');
    }
  };
  const onStartPressed = async () => {
    setIsCallStarted(true);
    setInitializingCall(true);
    const aa = await client.query({
      query: GET_TOKEN,
      fetchPolicy: 'network-only',
    });

    if (aa && aa.data && aa.data.getRetellWebCall) {
      setInitializingCall(false);

      await retellWebClient.startCall({
        accessToken: aa.data.getRetellWebCall.accessToken,
      });
    }
  };
  // When agent starts talking for the utterance
  // useful for animation
  retellWebClient.on('agent_start_talking', () => {
    setIsAgentTalking(true);
    // console.log('agent_start_talking');
  });

  // When agent is done talking for the utterance
  // useful for animation
  retellWebClient.on('agent_stop_talking', () => {
    setIsAgentTalking(false);
    // console.log('agent_stop_talking');
  });
  retellWebClient.on('call_ended', () => {
    // console.log('call ended');
    setIsCallStarted(false);
    setIsAgentTalking(false);
    forceNewComponent();
  });
  return (
    <Card style={{ margin: '12px' }}>
      <Flex flexDirection={'row'} style={{ padding: '12px' }}>
        <Flex>
          <Flex style={{ position: 'relative', overflow: 'hidden', height: '50px', width: '50px' }}>
            <Mic>
              {/* <MicIcon /> */}
              {!!isCallStarted && !initializingCall && <MicShadow isActive={isAgentTalking} />}
            </Mic>
          </Flex>
        </Flex>
        {!isCallStarted ? (
          <Flex flexDirection={'column'} ml={3}>
            <Text fontSize={'14px'}>Need help?</Text>
            <Button
              variant={'primary'}
              onClick={onStartPressed}
              style={{ paddingTop: '4px', paddingBottom: '4px', fontWeight: 300, display: 'flex', alignItems: 'center', border: '2px solid #344F79' }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '6px' }}>
                <path
                  d="M16.5559 12.906L16.1009 13.359C16.1009 13.359 15.0179 14.435 12.0629 11.497C9.10788 8.55898 10.1909 7.48298 10.1909 7.48298L10.4769 7.19698C11.1839 6.49498 11.2509 5.36698 10.6339 4.54298L9.37388 2.85998C8.60988 1.83998 7.13488 1.70498 6.25988 2.57498L4.68988 4.13498C4.25688 4.56698 3.96688 5.12498 4.00188 5.74498C4.09188 7.33198 4.80988 10.745 8.81388 14.727C13.0609 18.949 17.0459 19.117 18.6749 18.965C19.1909 18.917 19.6389 18.655 19.9999 18.295L21.4199 16.883C22.3799 15.93 22.1099 14.295 20.8819 13.628L18.9719 12.589C18.1659 12.152 17.1859 12.28 16.5559 12.906Z"
                  fill="white"
                />
              </svg>
              Voice chat
            </Button>
          </Flex>
        ) : (
          <Flex flexDirection={'column'} ml={3}>
            <Text fontSize={'14px'}>{initializingCall ? 'Calling...' : isAgentTalking ? 'Talk to interrupt...' : 'Listening...'}</Text>
            <Button
              variant={'outline'}
              disabled={!!initializingCall}
              onClick={onStopPressed}
              style={{ paddingTop: '4px', paddingBottom: '4px', fontWeight: 300, display: 'flex', alignItems: 'center' }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '6px' }}>
                <path
                  d="M3 21L21 3M5.831 14.161C4.15465 11.7528 3.17505 8.92895 3 6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4H9L11 9L8.5 10.5C8.608 10.72 8.723 10.935 8.845 11.145M10.596 13.422C11.4444 14.2682 12.4253 14.9701 13.5 15.5L15 13L20 15V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21C14.098 20.7668 10.4174 19.1097 7.656 16.343"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              End Call
            </Button>
          </Flex>
        )}
        <Flex flex={1} />
      </Flex>
    </Card>
  );
};

const RetellWebCall = ({ client }) => {
  const [componentKey, setComponentKey] = useState(0); // State to track the component's key

  useEffect(() => {
    const rem = async () => {
      await sleep(500);
      removeRetellWidget();
      // if (window.Beacon) {
      //   window.Beacon('on', 'ready', () => window.Beacon('destroy'));
      // } else {
      //   await sleep(3000);
      //   if (window.Beacon) {
      //     window.Beacon('on', 'ready', () => window.Beacon('destroy'));
      //   }
      // }
      await sleep(3000);
      try {
        removeRetellWidget();
        // window.Beacon('destroy');
      } catch (error) {}
    };
    // if (window.Beacon) {
    //   window.Beacon('on', 'ready', () => window.Beacon('destroy'));
    // }
    removeRetellWidget();
    rem();
    // Set the background color of the body when the component mounts
    document.body.style.backgroundColor = 'transparent';

    // Cleanup: Reset the background when the component unmounts
    return () => {
      document.body.style.backgroundColor = ''; // Reset to default
    };
  }, []);

  // Function to force the re-render of ComponentB by updating the key
  const forceNewComponent = () => {
    setComponentKey((prevKey) => prevKey + 1); // Change the key to force re-render
  };

  return <RetellWebCallComponent key={componentKey} client={client} forceNewComponent={forceNewComponent} />;
};

export default withApollo(RetellWebCall);
